import type React from 'react';
import { type FieldErrors } from 'react-hook-form';
import { Subject } from 'rxjs';

export type InvalidFormEvent =
  | { type: 'valid'; data: any }
  | { type: 'invalid'; errors: FieldErrors<any> | null }
  | { type: 'blur'; event: React.FocusEvent<HTMLFormElement, Element> };

export type InvalidFormSubject = Subject<InvalidFormEvent>;

/**
 * Crea il Subject (RxJS) che viene utilizzato per comunicare l'evento di
 * Submit con i risultati di validazione del Form.
 *
 * Essendo un Subject, è possibile sottoscriversi ad esso per ricevere gli
 * eventi (vedi hook `useInvalidFormEvent`), senza dover gestire re-render
 * dovuti al cambiamento delle Props.
 */
export function createInvalidFormSubject() {
  return new Subject<InvalidFormEvent>();
}
